import userListUtils from "../../../../../utils/userListUtils";
import DataService from "../../../../Application/services/dataServices/typedDataService";

import { type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import KnownHttpHeaders from "features/Application/services/knownHttpHeaders";
import { formatFiltersV2api, mapToV2Filters } from "utils/queryUtils";
import { escapeTerm } from "utils/searchUtils";
import { v2FilterMap, type GetContentUsersParams } from "../../../../People/types";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/GroupsSlice";

export const fetchGroupsAction =
  ({ entityId, skip, top, sortingColumn, sortingDirection, filter, term }: GetContentUsersParams): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(fetchBegin());
    try {
      const { filterParams } = userListUtils.getFetchUsersParams(term, sortingColumn, sortingDirection, filter);
      const response = await DataService.scorm.getGroups(
        entityId,
        skip,
        top,
        formatFiltersV2api(mapToV2Filters(filterParams, v2FilterMap)),
        escapeTerm(term),
      );

      const count = parseInt(response.headers[KnownHttpHeaders.RecordsCount]);
      const items = response.data;
      items.forEach((item) => (item.id = +item.groupId));
      dispatch(fetchSuccess({ items, totalCount: count }));
    } catch (e) {
      dispatch(fetchFailure(e as Error));
    }
  };
